<template>
	<el-container>
		<el-main class="reviewTaskManageMain-wrap">
			<div class="reviewTaskManageMain mt6 shadowlaw">
				<div class="filter filterReviewDetail">
					<el-form
						ref="form"
						:model="form"
						label-width="80px"
						class="clearfix"
					>
						<el-form-item label="建议类型">
							<el-select
								v-model="form.type"
								placeholder="请选择"
								:popper-append-to-body="false"
							>
								<el-option
									v-for="item in typeOptions"
									:key="item.id"
									:label="item.label"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="对应具体条款" class="termsW"  >
							<el-input :maxlength="50"
								v-model.trim="form.terms"
							></el-input>
						</el-form-item>
						<el-form-item label="创建时间">
							<el-date-picker
								v-model="form.time"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								value-format="yyyy-MM-dd"
							></el-date-picker>
						</el-form-item>
						<div class="operation fl operationReviewDetail">							
							<a class="new f_transition" @click="searchTable">
								<i class="iconfont icon-chaxun1"></i>
								查询
							</a>
							<a class="new f_transition" @click="resetFun">
								<i class="iconfont icon-zhongzhi"></i>
								重置
							</a>
						</div>
					</el-form>
				</div>
				<div class="tableBox tableBoxReviewDetail tableBoxReviewReport">
					<el-table
						ref="multipleTable"
						:data="tableData"
						tooltip-effect="dark"
						style="width: 100%"
						v-loading="loading"
					>
						<!-- <el-table-column type="selection" width="66">
						</el-table-column> -->
						<el-table-column
							prop="item_id__content"
							label="对应具体条款"
							min-width="40%"
							align="left"
							:show-overflow-tooltip="true"
						>
							<template slot-scope="scope">
								<span @click="titleFun(scope.row.id)">{{scope.row.item_id__content}}</span>
							</template>
						</el-table-column>
						<el-table-column
							prop="advise_type"
							label="建议类型"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="process"
							label="对应审查进度"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
							<template slot-scope="scope">
								<span>第{{scope.row.process}}轮</span>
							</template>
						</el-table-column>
						<el-table-column
							prop="report_list"
							label="对应审查报告"
							min-width="40%"
							align="center"
						>
							<template slot-scope="scope">
								<p v-for="(item,index) in scope.row.report_list" :key="index">{{item.report_title}}</p>
							</template>
						</el-table-column>
						<el-table-column
							prop="author_department"
							label="部门"
							min-width="20%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							prop="author_name"
							label="创建人"
							min-width="14%"
							:show-overflow-tooltip="true"
							align="center"
						>
						</el-table-column>
						<el-table-column
							label="创建时间"
							min-width="22%"
							:show-overflow-tooltip="true"
							align="center"
						>
							<template slot-scope="scope">{{
								handleTime(scope.row.create_time)
							}}</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="page pt15 pb15 clearfix pageReviewDetail">
					<el-pagination
						@size-change="handleSizeChangeDeclare"
						@current-change="handleCurrentChangeDeclare"
						:current-page.sync="currentPageDeclare"
						:page-size="pageSize"
						background
						layout="total ,prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
				<div class="fileBox" v-if="tableData&&tableData.length>0">
					<div class="fileBoxOperation hlh50 clearfix">
						<p class="fl title por">审查意见详情</p>
						<div
							class="operation fr pr36 mr35 operationReviewDetail"
						> 
							<a class="new f_transition" @click="editFun" v-if="curMode=='view'&&reviewStage!='task'&&reviewStageStatus=='进行中'">
								<i class="iconfont icon-bianji"></i>
								编辑
							</a>
							<a class="new f_transition" @click="submitFunAmend('ruleForm')" v-if="curMode=='edit'&&reviewStageStatus=='进行中'">
								<i class="iconfont icon-keep"></i>
								保存
							</a>
							<a class="new f_transition" @click="deleteFun" v-loading="loadingDel" v-if="reviewStage!='task'&&reviewStageStatus=='进行中'">
								<i class="iconfont icon-shanchu"></i>
								删除
							</a>
						</div>
					</div>
					<div class="fileBoxCon fileBoxConReviewOpinion">
						<happy-scroll
							size="3"
							color="#c1c4c6"
							:hide-horizontal="true"
							resize
						>
							<div class="con">	
								<!-- 查看 -->
								<div class="filter filterReviewOpinion filterReviewOpinionNoEdit" v-if="curMode=='view'" v-loading="loadingView">
									<el-form
										:model="formView"
										label-width="110px"
										class="clearfix"
										key="view"
									>
										<el-form-item label="对应具体条款" class="itemW40">
											<el-input v-model="formView.terms" readonly type="textarea"></el-input>
										</el-form-item>
										<el-form-item label="建议类型" class="itemW40">
											<el-input v-model="formView.type" readonly></el-input>
										</el-form-item>
										<el-form-item label="审查建议内容" class="textareaItem itemW90">
											<el-input
												type="textarea"
												:autosize="{ minRows: 2, maxRows: 10 }"
												v-model.trim="formView.con"
												readonly
											></el-input>
										</el-form-item>
										<el-form-item label="依据和理由" class="textareaItem itemW90">
											<el-input
												type="textarea"
												:autosize="{ minRows: 2, maxRows: 10 }"
												v-model.trim="formView.reason"
												readonly
											></el-input>
										</el-form-item>
										<el-form-item label="条目原文" class="textareaItem itemW90">
											<el-input
												type="textarea"
												:autosize="{ minRows: 2, maxRows: 10 }"
												v-model.trim="formView.yw"
												readonly
											></el-input>
										</el-form-item>
									</el-form>
								</div>
								<!-- 编辑 -->
								<div class="filter filterReviewOpinion" v-loading="loadingAdvice" v-if="curMode=='edit'">
									<el-form
										ref="ruleForm"
										:model="formEdit"
										:rules="rulesEdit"
										label-width="110px"
										class="clearfix"
										key="edit"
									>
										<el-form-item label="对应具体条款" class="itemW40">
											<el-input v-model="formEdit.terms" disabled></el-input>
										</el-form-item>
										<el-form-item label="建议类型" class="itemW40">
											<el-input v-model="formEdit.type" disabled></el-input>
										</el-form-item>
										<el-form-item label="审查建议内容" class="textareaItem itemW90" prop="con">
											<el-input
												type="textarea"
												:autosize="{ minRows: 8, maxRows: 20 }"
												placeholder="请输入审查建议内容"
												v-model.trim="formEdit.con"
												:clearable="true"
											></el-input>
										</el-form-item>
										<el-form-item label="依据和理由" class="textareaItem itemW90" prop="reason">
											<el-input
												type="textarea"
												:autosize="{ minRows: 8, maxRows: 20 }"
												placeholder="请输入依据和理由"
												v-model.trim="formEdit.reason"
												:clearable="true"
											></el-input>
										</el-form-item>
										<el-form-item label="条目原文" class="textareaItem itemW90">
											<el-input
												type="textarea"
												:autosize="{ minRows: 8, maxRows: 20 }"
												v-model.trim="formEdit.yw"
												disabled
											></el-input>
										</el-form-item>
									</el-form>
								</div>
							</div>
						</happy-scroll>
					</div>
				</div>
			</div>
		</el-main>
	</el-container>
</template>
<script>
//编辑审查意见
// import addReviewOpinions from "../recordReview/addReviewOpinions.vue"
export default {
	components:{
		// addReviewOpinions
	},
	data() {
		return {
			//筛选条件start==
			typeOptions: [//建议类型
				{
					id: "null",
					label: "全部",
				},				
				{
					id: "修改",
					label: "修改",
				},
				{
					id: "增加",
					label: "增加",
				},
				{
					id: "删除",
					label: "删除",
				},
			],
			form: {
				type: "null", //建议类型
				terms: "", //对应具体条款
				time: [], //时间
			},
			//筛选条件end==

			//表格start==
			loading: false, //加载中
			tableData: [],//表格数据
			multipleSelection: [], //表格选中数据
			//表格end==

			//分页start==
			currentPageDeclare: 1, //当前页
			total: 0, // 总共条数
			pageSize: 5, //每页的数量
			//分页end==

			//下方查看
			formView: {
				terms: "", //对应具体条款
				type: "", //建议类型
				con: "", //审查建议内容
				reason: "", //依据和理由
				yw:"",//条目原文
			},
			loadingView:false,//查看数据加载中
			//下方编辑
			formEdit: {
				terms: "", //对应具体条款
				type: "", //建议类型
				con: "", //审查建议内容
				reason: "", //依据和理由
				yw:"",//条目原文
			},
			rulesEdit: {
				con: [
					{
						required: true,
						message: "请输入审查建议内容",
						trigger: "blur",
					},
				],
				reason: [
					{
						required: true,
						message: "请输入依据和理由",
						trigger: "blur",
					},
				],
			},
			loadingAdvice:false,//加载中 编辑
			curUuid:"",//当前的uuid
			curMode:"view",//默认查看

			taskUuid:"",//任务的uuid
			curOpinionId:Number,//当前报告的id
			loadingDel:false,//删除遮罩
			report_id:Number,//报告id
			reviewStage:"",//审查进度

			advice_recommend_list:[],//关联对象
			reviewStageStatus:"",//审查状态
		};
	},
	created() {
		this.report_id=parseInt(window.localStorage.getItem("report_id"));
		this.reviewStage=window.localStorage.getItem("reviewStage");//审查进度 
		this.reviewStageStatus=window.localStorage.getItem('reviewStageStatus');//审查状态 为进行中时编辑保存删除按钮才显示

		//从审查报告跳转过来需要先通过报告id获取对应任务的uuid
		if(window.localStorage.getItem("reviewStage")=='task'){
			this.axios
				.get(
					"/japi/check/get_task_by_report_id/?report_id="+this.report_id
				)
				.then(res => {
					console.log("获取任务的uuid======");
					console.log(res);
					if (res.data.code == 200) {
						window.localStorage.setItem("taskUuid",res.data.data);//任务的uuid					
					}else{
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000
						});
					}
				});
		}
		this.taskUuid=window.localStorage.getItem("taskUuid");//任务的uuid
		this.tableFun(1);
	},
	methods: {
		//分页
		handleSizeChangeDeclare(size) {
			// console.log(`每页 ${size} 条`);
			this.pageSize = size;
			this.tableFun(this.currentPageDeclare);
		},
		handleCurrentChangeDeclare(currentPage) {
			// console.log(`当前页: ${currentPage}`);
			this.currentPageDeclare = currentPage;
			this.tableFun(this.currentPageDeclare);
		},
		//将时间中的T换成空格
		handleTime(t) {
			t = t.replace(new RegExp(/(T)/g), "\u00a0");
			return t;
		},
		//重置
		resetFun() {
			this.form.type = "null"; //建议类型
			this.form.terms = ""; //对应具体条款
			this.form.time = []; //时间
			this.currentPageDeclare=1;
			this.tableFun(1);
		},
		//域内检索
		searchTable() {
			this.currentPageDeclare=1;
			this.tableFun(1);
		},
		//获取table中的数据 uuid为任务的uuid
		tableFun(str) {
			this.loading = true; //加载中显示
			let startTime = "";
			let endTime = "";
			if (this.form.time&&this.form.time.length > 0) {
				startTime = this.form.time[0];
				endTime = this.form.time[1];
			} else {
				startTime = "";
				endTime = "";
			}
			let me = this;
			this.axios
				.get(
					"/japi/check/check_advices_handle/?tag=task&page=" +
						str +
						"&page_num=" +
						this.pageSize +
						"&uuid="+this.taskUuid+
						"&advise_type__contains=" +
						this.form.type +
						"&item_id__content__contains=" +
						this.form.terms+
						"&create_time__gte=" +
						startTime +
						"&create_time__lte=" +
						endTime
				)
				.then((res) => {
					console.log("审查意见表格数据======");
					if (res.data.code == 200) {
						console.log(res);
            me.loading = false; //加载中隐藏
						if(res.data.data.sum > 0)
            {
              me.total = res.data.data.sum;
              me.tableData = res.data.data.res;
              // this.curUuid=res.data.data.res[0].

              if(me.tableData.length>0){
                me.curOpinionId=this.tableData[0].id;//当前报告的id
                me.getDataFun(this.tableData[0].id);//获取审查详情
              }
            }
						else
            {
              me.tableData = []
              me.$message.error("没有查询到数据");
            }

					} else {
						console.log("请求数据失败！");
            me.$message.error(res.data.msg);
					}
				});
		},

		//查看意见详情
		getDataFun(id){
			this.loadingView=true;//加载中显示
			this.id=id;//意见id
			this.axios.get('/japi/check/check_advices_handle/?tag=detail&uuid='+id).then(res =>{
				if (res.data.code == 200) {
					console.log("查看意见数据======");
					console.log(res);
					this.loadingView=false;//加载中隐藏

					this.formView.terms=res.data.data[0].item_id__content; //对应具体条款
					this.formView.type=res.data.data[0].advise_type; //建议类型
					this.formView.con=res.data.data[0].content; //审查建议内容
					this.formView.reason=res.data.data[0].reason; //依据和理由
					this.formView.yw=res.data.data[0].item_id__content; //原文

					this.formEdit.terms=res.data.data[0].item_id__content; //对应具体条款
					this.formEdit.type=res.data.data[0].advise_type; //建议类型
					this.formEdit.con=res.data.data[0].content; //审查建议内容
					this.formEdit.reason=res.data.data[0].reason; //依据和理由
					this.formEdit.yw=res.data.data[0].item_id__content; //原文
					this.advice_recommend_list=res.data.data[0].advice_recommend_list;//关联对象


				} else if(res.data.code == 500){
					this.$message({
						message: res.data.msg,
						type: "warning",
						duration: 3000
					});
				}
			});
		},
		//点击标题 下方切换报告数据详情
		titleFun(id){
			this.curOpinionId=id;//当前报告的id
			this.getDataFun(id);//查看意见详情
		},

		//编辑
		editFun() {
			this.curMode="edit";
		},
		//删除
		deleteFun() {
			this.$confirm('请确认是否删除当前查看的审查意见数据？', "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
				closeOnClickModal:false  //是否可通过点击遮罩关闭MessageBox
			}).then(() => { //确定
				this.loadingDel=true;
				this.axios({
					method:'delete',
					url:"/japi/check/check_advices_handle/",
					data:{
						id:this.curOpinionId
					}
				}).then(res =>{
					if (res.data.code == 200) {
						console.log("意见删除成功======");
						console.log(res);
						//遮罩隐藏
						this.loadingDel=false;
						this.$message({
							message: "意见删除成功",
							type: "success",
							duration: 3000
						});							
						// //此处需要先将删除元素从表格数据中移出 获取第一条数据的id进行数据请求
						// this.tableData.forEach((item,index)=>{
						// 	if(item.id==this.curOpinionId){
						// 		this.tableData.splice(index,1);
						// 	}
						// })
						// this.curOpinionId=this.tableData[0].id;						
						this.tableFun(this.currentPageDeclare);//获取数据	
						// this.getDataFun(this.tableData[0].id);//获取审查详情
					} else if(res.data.code == 500){
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000
						});
					}
					else{
						this.$message({
							message: res.data.msg,
							type: "warning",
							duration: 3000
						});
					}
				});					
			}).catch(()=>{ //不加catch会报错
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		//修改意见
		submitFunAmend(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.loadingAdvice=true;
					let formData = new FormData();
					formData.append("id",this.curOpinionId);//意见id
					// formData.append("item_id",this.form.terms);//对应具体条款的uuid
					// formData.append("advise_type",this.form.type); //意见类型
					formData.append("content", this.formEdit.con); //审查建议内容内容
					formData.append("reason", this.formEdit.reason); //理由和依据
					formData.append("advice_recommend_list",JSON.stringify(this.advice_recommend_list)); //关联对象

					this.axios({
						method: "put",
						url: "/japi/check/check_advices_handle/",
						data: formData
					}).then(res => {
						if (res.data.code == 200) {
							console.log("意见修改成功======");
							console.log(res);
							//遮罩隐藏
							this.loadingAdvice=false;
							this.$message({
								message: "意见修改成功",
								type: "success",
								duration: 3000
							});							
							this.curMode="view";//查看
							this.getDataFun(this.curOpinionId);//获取意见详情
						} else if(res.data.code == 500){
							this.$message({
								message: res.data.msg,
								type: "warning",
								duration: 3000
							});
						}
						else{
							this.$message({
								message: res.data.msg,
								type: "warning",
								duration: 3000
							});
						}
					});
				} else {
					// console.log('error submit!!');
					return false;
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/css/mixin.scss"; //定义方法
@import "../../../../assets/css/recordReviewDetail.scss"; //备案审查详情页样式
</style>